<div>
  <div class="row">
    <div class="col-12">
      <span class="tlm-section-title">Emails</span>
      <button type="button" id="addEmail" class="btn btn-link tlm-link pull-right" (click)="createAndAddItemToListIfPopulated()">+ Add Email</button>
    </div>
  </div>
  <div *ngFor="let emailFormGroup of emailsFormArray.controls; let i = index">
    <app-tlm-edit-threat-email
      [emailFormGroup]="emailFormGroup"
      [index]="i"
      [length]="emailsFormArray.controls.length"
      [removeItem]="boundRemoveItem"
      [isPopulated]="boundIsPopulated"
      [matAppearance]="matAppearance"
      [errorMatcher]="errorMatcher"
    >
    </app-tlm-edit-threat-email>
  </div>
</div>
